import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CATEGORIES } from "@/lib/api";

export const CatSelect = ({ value, onChange, testid }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>
      {CATEGORIES.map((c) => <SelectItem key={c.value} value={c.value} data-testid={`${testid}-option-${c.value}`}>{c.label}</SelectItem>)}
    </SelectContent>
  </Select>
);
